import React from 'react';
import { LoadingSpinner } from '@repo/ui/components';

export const ColLoading = () => (
  <div className="-mt-[10px]">
    <LoadingSpinner size={28} />
  </div>
);
